import { UPDATEBILL } from "../../utils/api";
import axios from "../../utils/axios";

export const UpdateBillCounterSell = async (params) => {
    const res = await axios.post(UPDATEBILL, params);
    return res;
  };
  